"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getQueryValueFromCookie = exports.getRefValueFromCookie = exports.getCleanedUpQuery = exports.handleRef = exports.appendSearchQuery = exports.REFS_UK = exports.REFS_BR = exports.REFS_US = exports.handleRefsUk = exports.handleRefsBr = exports.handleRefsUs = exports.QUERY_COOKIE_KEY = exports.REF_COOKIE_KEY = void 0;
const cookie_1 = require("./cookie");
const dom_helpers_1 = require("./dom-helpers");
const first_touch_tracking_1 = require("./first-touch-tracking");
exports.REF_COOKIE_KEY = 'ref';
exports.QUERY_COOKIE_KEY = 'query';
function handleRefsUs(searchRef = exports.REFS_US.SEO_US_SEARCH, directRef = exports.REFS_US.SEO_US_DIRECT, { shouldAddFormFields = true } = {}) {
    return handleRef(searchRef, directRef, { shouldAddFormFields });
}
exports.handleRefsUs = handleRefsUs;
function handleRefsBr(searchRef = exports.REFS_BR.SEO_BR_DEFAULT, directRef = exports.REFS_BR.SEO_BR_DEFAULT, { shouldAddFormFields = true } = {}) {
    return handleRef(searchRef, directRef, { shouldAddFormFields });
}
exports.handleRefsBr = handleRefsBr;
function handleRefsUk(searchRef = exports.REFS_UK.SEO_UK_SEARCH, directRef = exports.REFS_UK.SEO_UK_DIRECT, { shouldAddFormFields = true } = {}) {
    return handleRef(searchRef, directRef, { shouldAddFormFields });
}
exports.handleRefsUk = handleRefsUk;
exports.REFS_US = {
    SEO_US_DIRECT: '087ddc3cb81537f6',
    SEO_US_SEARCH: '1d1999c8d5115a7b',
    SEO_US_LANDING_PAGES: 'b90dba6fb25ed378',
    SEO_US_BLOG: 'a5f7a818d882293a',
    SEO_US_LATEST_ORDERS: 'e85cd0f62e9541a1',
    SEO_US_TAGS: '0bf4d1c2b820062f',
    SEO_US_AUTHORS: 'fcdb29b4825fd41c',
    SEO_US_PLAGIARISM: 'b75e3db9c2d2b5bd',
    SEO_US_FINISHED_WORKS: '3afc3c319bde0eae',
    SEO_US_REVIEWS: '7410ad1b6b358156',
    MARKETING_US_PPC: 'ac76fb5b31c0b4c6',
    MARKETING_RESEARCH_PAPER: '4769d0965ecd6320',
    SEO_US_INFO: '78263f1617cd3384',
    SEO_US_BECOME_AUTHOR: '01f22c2832ba9333',
    SEO_US_ORDER: 'f15f531f27434972',
};
exports.REFS_BR = {
    SEO_BR_DEFAULT: '4d8e8d622807571e',
    SEO_BR_HF_PAGES: 'e49b1b78b89220fa',
    SEO_BR_BLOG: '1d10f08780852c55',
    SEO_BR_READY_WORKS_ALL_PAGES: '053589cfa745cbdc',
    SEO_BR_READY_WORKS_WORK_PAGES: '9c0368f61a82a752',
};
exports.REFS_UK = {
    SEO_UK_DIRECT: '2cc6f0f412e0a477',
    SEO_UK_SEARCH: '3d6be20ed7ec2c6d',
    SEO_UK_BLOG_MAIN: 'f4f4dc8b603f1eea',
    SEO_UK_BLOG_CATEGORY: '95859fdcd42a7b2e',
    SEO_UK_BLOG_ARTICLE: 'd5bd6f9bc1c9e28b',
    SEO_UK_CHATBOT: 'c558774086c7000c',
    SEO_UK_REVIEWS: '3d83228d86cd1c7b',
    SEO_UK_PLAGIARISM: '131a4269fb67ccc7',
    SEO_UK_AUTHORS: 'c6510d3c4d2012b6',
    SEO_UK_HF_PAGE: 'b9f88a9ba7fd7372',
};
function appendSearchQuery(url, ref = '', query = '') {
    return `${url}${/\?/.test(url) ? '&' : '?'}ref=${ref}&${query}`;
}
exports.appendSearchQuery = appendSearchQuery;
function handleRef(searchRef = exports.REFS_US.SEO_US_SEARCH, directRef = exports.REFS_US.SEO_US_DIRECT, { shouldAddFormFields = true } = {}) {
    const query = new URLSearchParams(document.location.search);
    const refFormUrl = getRefFromQuery(query);
    let cleanedQuery = getCleanedUpQuery(query);
    const refFromCookie = (0, cookie_1.getCookie)(exports.REF_COOKIE_KEY);
    let currentRef;
    if (refFromCookie) {
        currentRef = refFromCookie;
        cleanedQuery = (0, cookie_1.getCookie)(exports.QUERY_COOKIE_KEY);
    }
    else if (refFormUrl) {
        currentRef = refFormUrl;
    }
    else if (isFromSearch()) {
        currentRef = searchRef;
    }
    else {
        currentRef = directRef;
    }
    const shouldSetRefToCookie = currentRef !== undefined && refFromCookie === undefined;
    if (shouldSetRefToCookie) {
        (0, cookie_1.setCookieWithDomain)(exports.REF_COOKIE_KEY, currentRef);
        (0, cookie_1.setCookieWithDomain)(exports.QUERY_COOKIE_KEY, cleanedQuery);
    }
    if (shouldAddFormFields) {
        addFastregFormFields(currentRef);
    }
    return {
        ref: currentRef || '',
        query: cleanedQuery || ''
    };
}
exports.handleRef = handleRef;
function getRefFromQuery(query) {
    var _a;
    return (_a = query.get('ref')) !== null && _a !== void 0 ? _a : query.get('refid');
}
function getCleanedUpQuery(query, omitParams = PARAMETERS_TO_OMIT) {
    for (const parameterToOmit of PARAMETERS_TO_OMIT) {
        query.delete(parameterToOmit);
    }
    return query.toString();
}
exports.getCleanedUpQuery = getCleanedUpQuery;
function isFromSearch() {
    var _a;
    return Boolean(((_a = document.referrer) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
        document.referrer.match(/^https?:\/\/([^\/]+\.)?(google|duckduckgo|bing|yahoo)\.com(\/|$)/i));
}
function getRefValueFromCookie() {
    return (0, cookie_1.getCookie)(exports.REF_COOKIE_KEY) || '';
}
exports.getRefValueFromCookie = getRefValueFromCookie;
function getQueryValueFromCookie() {
    return (0, cookie_1.getCookie)(exports.QUERY_COOKIE_KEY) || '';
}
exports.getQueryValueFromCookie = getQueryValueFromCookie;
const PARAMETERS_TO_OMIT = [
    'ref',
    'refid',
    'search',
    'disciplines',
    'types',
    'page',
    first_touch_tracking_1.REFERRER_COOKIE_NAME,
    first_touch_tracking_1.FIRST_PAGE_COOKIE_NAME
];
function addFastregFormFields(ref) {
    const serviceForms = Array.from(document.querySelectorAll(first_touch_tracking_1.SERVICE_FORMS_SELECTOR));
    serviceForms.forEach(form => {
        form.appendChild((0, dom_helpers_1.createHiddenInput)(exports.REF_COOKIE_KEY, ref));
    });
}
